<template>
  <header class="header">
    <div class="filters">

      <advertising-filter v-if="canReadCampaign"
                          data-entity="comments"
                          :multiple="false"></advertising-filter>

      <app-date-range-filter data-entity="comments"></app-date-range-filter>

      <LocalEstableshimentFilter data-entity="comments" />

      <button class="btn btn-extra-round btn-primary"
              @click="emitFilterLoad">{{$t('message.generics.message.fetchData')}}</button>

      <div class="search-wrapper">
        <app-search-bar @input="search"
                        @enter="emitFilterLoad"></app-search-bar>
      </div>
    </div>

    <i class="mdi mdi-file-download-outline mr-4"
       v-tooltip.auto="$t('message.generics.message.exportCsv')"
       @click="download"></i>
  </header>
</template>

<script>
import AppSearchBar from "@components/Search";
import AdvertisingFilter from "@components/filters/AdvertisingFilter";
import AppDateRangeFilter from "@components/filters/DateRangeFilter";
import LocalEstableshimentFilter from "@components/filters/LocalEstableshimentFilter";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppDateRangeFilter,
    AppSearchBar,
    LocalEstableshimentFilter,
    AdvertisingFilter,
  },

  computed: {
    filters() {
      return this.$store.state.comments.filters;
    },
    canReadCampaign() {
      return this.$store.state.users.user.permissions.includes("READ_CAMPAIGN");
    },
  },

  methods: {
    emitFilterLoad() {
      EventBus.$emit("COMMENTS_LOAD");
    },

    search(value) {
      this.$store.commit("COMMENTS_SET_FILTER", {
        key: "search",
        value: value,
      });
    },

    async download() {
      try {
        const csv = await this.$api.comments.fetchCsv({
          filters: this.filters,
        });

        const link = this.createElement(csv);

        link.click();
      } catch (error) {
        console.log(error);
      }
    },

    createElement(csv) {
      const url = window.URL.createObjectURL(new Blob([csv]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "comentários.csv");
      document.body.appendChild(link);

      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
  display: flex;
  align-items: center;
  justify-content: center;

  .filters {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 2% 0 12%;
    flex-grow: 1;

    .search-wrapper {
      max-width: 200px;
    }
  }

  .search-wrapper {
    max-width: 200px;
  }

  .mdi {
    font-size: 28px;
    color: $grey-6;
    cursor: pointer;

    &.active {
      color: $blue-primary;
    }

    &.mdi-view-grid {
      font-size: 22px;
    }
  }
}
</style>
